/**
 * Server-side Sanity utilities. By having these in a separate file from the
 * utilities we use on the client side, we are able to tree-shake (remove)
 * code that is not used on the client side.
 */
import { createClient } from 'next-sanity'
import { sanityConfig } from './config'

const actualSanityClient = createClient(sanityConfig)

export const sanityClient = {
  async fetch(query, options) {
    query = query.replace(/\s/g, '')
    const result = await actualSanityClient.fetch(query, options)
    return result
  },
}

export const actualPreviewClient = createClient({
  ...sanityConfig,
  useCdn: false,
  token: process.env.SANITY_API_TOKEN,
})

export const previewClient = {
  async fetch(query, options) {
    query = query.replace(/\s/g, '')
    const result = await actualPreviewClient.fetch(query, options)
    return result
  },
}

export const getClient = preview => (preview ? previewClient : sanityClient)
